import React from "react";
import styled from "styled-components";
import {
  Ca100Package,
  PublicMetric,
} from "../../../models/CompanyprofileModels";

import {
  ElementContainer,
  FlexibleContainer,
  RowContainer,
} from "../../../components/containers/styledComponents";
import { CA100RadarChart } from "./CA100Radar";
import { CA100Accordion } from "./CA100AccordionItem";
import {
  CA100_DISCLOSURE_TREE,
  CA100_LOBBYING_TREE,
  DisclosureTreeNode,
  LOBBYING_BARS_METRIC_IDS,
  LobbyingTreeNode,
} from "./CA100Constants";
import { CompassParagraph } from "../../../components/common/styledComponents";
import { greyText, lightGreyOutline } from "../../../styles";
import { MESSAGES } from "../../../messages";
import { CA100Bar } from "./CA100Bar";

const Column = styled.div<{ border?: boolean }>`
  flex: 1;
  box-sizing: border-box;
  ${({ border }): string | false | undefined =>
    border && `border-right: 1px solid ${lightGreyOutline};`}
`;

export const TabCA100 = ({
  metricsData,
}: {
  metricsData: PublicMetric[];
}): JSX.Element => {
  return (
    <RowContainer ai="flex-start" jc="flex-start">
      <Column border={true}>
        <ElementContainer flexDirection="column" mb={32} pt={12}>
          <CompassParagraph fontSize={14} bold={true}>
            {MESSAGES.COMPANY_PROFILE.NZA.CA100.DISCLOSURE_TITLE}
          </CompassParagraph>
          <CompassParagraph color={greyText}>
            {MESSAGES.COMPANY_PROFILE.NZA.CA100.DISCLOSURE_DESCRIPTION}
          </CompassParagraph>
        </ElementContainer>
        <FlexibleContainer
          f={1}
          h="300px"
          w="100%"
          ai="center"
          jc="space-between"
          p="0px 32px 0px 0px"
        >
          <CA100RadarChart metricsData={metricsData} />
        </FlexibleContainer>
        <FlexibleContainer
          h="300px"
          ofy="auto"
          fd="column"
          jc="flex-start"
          ai="flex-start"
          mt="24px"
        >
          {CA100_DISCLOSURE_TREE.map((node: DisclosureTreeNode) => (
            <CA100Accordion<DisclosureTreeNode>
              key={node.id}
              node={node as DisclosureTreeNode}
              metricsData={metricsData}
              dataPackage={Ca100Package.DISCLOSURE}
            />
          ))}
        </FlexibleContainer>
      </Column>

      <Column>
        <ElementContainer flexDirection="column" mb={12} pt={12} ml={24}>
          <CompassParagraph fontSize={14} bold={true}>
            {MESSAGES.COMPANY_PROFILE.NZA.CA100.LOBBYING_TITLE}
          </CompassParagraph>
          <CompassParagraph color={greyText}>
            {MESSAGES.COMPANY_PROFILE.NZA.CA100.LOBBYING_DESCRIPTION}
          </CompassParagraph>
        </ElementContainer>
        <FlexibleContainer
          f={1}
          fd="column"
          h="300px"
          w="100%"
          ai="flex-start"
          jc="flex-start"
          p="0px 0px 0px 24px"
          ofy="auto"
        >
          {LOBBYING_BARS_METRIC_IDS.map((metricId) => (
            <CA100Bar
              key={metricId}
              metricsData={metricsData}
              metricId={metricId}
            />
          ))}
        </FlexibleContainer>
        <FlexibleContainer
          h="300px"
          ofy="auto"
          fd="column"
          jc="flex-start"
          ai="flex-start"
          mt="44px"
          ml="24px"
        >
          {CA100_LOBBYING_TREE.map((node: LobbyingTreeNode) => (
            <CA100Accordion<LobbyingTreeNode>
              key={node.id}
              node={node as LobbyingTreeNode}
              metricsData={metricsData}
              dataPackage={Ca100Package.LOBBYING}
            />
          ))}
        </FlexibleContainer>
      </Column>
    </RowContainer>
  );
};
